<script>
import { marcaState } from '@/services/marca';

export default {
  name: 'AppFooter',
  computed: {
    // Nome de exibição configurável (whitelabel) usado no copyright.
    nomeExibicao() {
      return marcaState.nome_exibicao || 'PC do B';
    },
  },
};
</script>

<template>
  <footer class="footer footer-pcdob">
    <BContainer fluid>
      <BRow>
        <BCol col sm="6">
          {{ new Date().getFullYear() }} &copy; {{ nomeExibicao }}.
        </BCol>
        <BCol col sm="6">
          <div class="text-sm-end d-none d-sm-block">
            Desenvolvido por facilita.ae
          </div>
        </BCol>
      </BRow>
    </BContainer>
  </footer>
</template>

<style scoped>
.footer-pcdob {
  background-color: var(--vz-light, #f3f6f9);
  border-top: 1px solid #dfe3e8;
  color: var(--brand-primary, #971219);
}

:global([data-bs-theme="dark"] .footer-pcdob) {
  border-top-color: #2c0407;
}
</style>
